// DS: DEV1
import { URLS } from '@wix/da-url';
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Points from '@wix/da-ds/pkg/Icons/Points';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { getPointsPriceValidationError, POINTS_MIN_VALUE, } from '../utils/profits';
import s from './PointsInput.scss';
export var PointsInput = function (_a) {
    var className = _a.className, inputClassName = _a.inputClassName, value = _a.value, maxValue = _a.maxValue, label = _a.label, errorMessage = _a.errorMessage, showWhatArePointsLink = _a.showWhatArePointsLink, onChange = _a.onChange, refInput = _a.refInput;
    var t = useTranslation().t;
    var handleChange = function (ev) {
        var stringValue = ev.target.value;
        var limitedValue = Math.abs(+Number(stringValue.slice(0, 6)).toFixed(0));
        onChange(limitedValue, getPointsPriceValidationError(limitedValue, maxValue, t));
    };
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: s['points-input-line'] },
            React.createElement(TextInput, { id: "points-input", className: classnames(s['points-cost-input'], inputClassName), value: value ? value.toString() : '', validationResult: errorMessage ? 'error' : undefined, details: errorMessage, onChange: handleChange, name: "pointsInput", type: "number", label: label || t('common.pointsInput.choosePrice'), min: POINTS_MIN_VALUE, max: maxValue, autoComplete: "off", ref: refInput }),
            React.createElement("div", { className: s['input-label'] },
                React.createElement(Points, { className: s['coins-icon'] }))),
        showWhatArePointsLink && (React.createElement("div", { className: s['what-are-points-line'] }, !!value && (React.createElement("a", { target: "_blank", rel: "noreferrer", href: URLS.ABOUT_POINTS, className: s['what-are-points'] }, t('common.faq.whatArePoints')))))));
};
PointsInput.displayName = 'PointsInput';
export default PointsInput;
//# sourceMappingURL=PointsInput.js.map